import { render, staticRenderFns } from "./DaysOfWeekWithThresholdSettingForm.vue?vue&type=template&id=37d4f85a&scoped=true&"
import script from "./DaysOfWeekWithThresholdSettingForm.vue?vue&type=script&lang=js&"
export * from "./DaysOfWeekWithThresholdSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d4f85a",
  null
  
)

export default component.exports